import { FAQPage, Question, WithContext } from 'schema-dts'
import { isNonEmptyString } from '../checks'

type QuestionAnswer = {
  question: string
  answer: string
}

const faqPageSchema = (
  questionAnswers: QuestionAnswer[]
): WithContext<FAQPage> => {
  const mainEntity = questionAnswers
    .filter(
      ({ question, answer }) =>
        isNonEmptyString(question) && isNonEmptyString(answer)
    )
    .map((questionAnswer) => questionAnswerSchema(questionAnswer))

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity
  }
}

const questionAnswerSchema = (questionAnswer: QuestionAnswer): Question => {
  return {
    '@type': 'Question',
    name: questionAnswer.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: questionAnswer.answer
    }
  }
}

export default faqPageSchema
